import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminMlpsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('mlp');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
